/**
 * First we will load all of this project's JavaScript dependencies which
 * includes React and other helpers. It's a great starting point while
 * building robust, powerful web applications using React + Laravel.
 */
require("./bootstrap");
require("./generatePassword");
require("./togglePasswordIcon");
require("./header");
require("./videoPlaybackSpeed");
require("./selectedTableRow");
require("./disabledSendBtn");
require("./audioPlaybackSpeed");
// require('./audioPlayAll');

/**
 * Next, we will create a fresh React component instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
require("./components/Spinner");
require("./components/Manual");
require("./components/VideoCategoryBtn");
require("./components/E_Books");
require("./components/DictationNote");
require("./components/HowToAppNote");
require("./components/Handouts");
require("./components/DictationOverlapping");
require("./components/PartOfSpeech");
require("./components/Kikutan");
require("./components/Yumetan");
require("./components/Faq");
require("./components/StudyplusPop");
require("./components/ShowPop");
require("./components/CoreGrammar");
require("./components/behaviorTrigger/BehaviorTrigger");
